<template>
  <div class="ticket-solution-cell flex flex-col">
    <span class="ticket-solution-cell__type font-bold">{{ assetType }}</span>
    <span class="visually-hidden"> — </span>
    <span class="ticket-solution-cell__solution">{{ solution }}</span>
  </div>
</template>

<script setup>
/**
 * @component TicketSolutionCell
 * @description Cella composta per DataTable: mostra la tipologia asset in grassetto sopra
 * e il nome della soluzione/prodotto sotto. Il valore di `assetType` deve essere già
 * formattato (es. tradotto) dal chiamante — il componente non fa lookup i18n.
 * Usare come `component` in una colonna di `DataTable.columns`.
 *
 * @prop {String} assetType - Tipologia asset già tradotta (es. "Server Dedicato"), mostrata in grassetto sopra.
 * @prop {String} solution  - Nome della soluzione/prodotto (cf_sold_solution), mostrato sotto.
 *
 * @slot — nessuno slot esposto
 */
defineProps({
  assetType: {
    type: String,
    default: ""
  },
  solution: {
    type: String,
    default: ""
  }
})
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";

.ticket-solution-cell {
  gap: 2px;
}
</style>
